import { useEffect, useState } from "react";

/**
 * Returnerar true först när webbläsaren är klar med det viktiga.
 * Används för att skjuta upp allt som inte behövs för första intrycket
 * (cookieruta, analys, skanningsdockan ...) så att sidan blir interaktiv snabbt.
 */
export function useIdleMount(timeout = 2000): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    const done = () => {
      if (!cancelled) setReady(true);
    };
    const ric = (window as unknown as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number })
      .requestIdleCallback;
    if (ric) {
      const id = ric(done, { timeout });
      return () => {
        cancelled = true;
        (window as unknown as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(id);
      };
    }
    const t = window.setTimeout(done, 600);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, [timeout]);
  return ready;
}
